module.exports = __webpack_public_path__ + "img/image_28.6741225e.png";